"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequestCameraFlip = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const ui_react_1 = require("@streem/ui-react");
const room_session_1 = require("../../../context/room_session");
const rxjs_1 = require("../../../hooks/rxjs");
const toolbox_1 = require("@streem/toolbox");
const streem_sdk_protobuf_1 = require("streem-sdk-protobuf");
const take_first_emitted_1 = require("../../../util/take_first_emitted");
const TIMEOUT_MS_FLIP_CAMERA_REQUEST = 15000;
const RequestCameraFlip = ({ open, setOpen }) => {
    const timeoutRef = (0, react_1.useRef)();
    const roomSession = (0, room_session_1.useRoomSession)();
    const [request] = (0, rxjs_1.useObservable)(roomSession.camera.latestRequest);
    const clearTimeOutFlipCamera = () => {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = undefined;
        }
    };
    const handleAbortCameraFlip = (0, react_1.useCallback)(() => {
        (0, toolbox_1.invariant)(request, 'Attempted to abort undefined request.');
        roomSession.camera.abortCameraSubjectChangeRequest(request.id);
        setOpen(false);
    }, [request, roomSession.camera, setOpen]);
    (0, react_1.useEffect)(() => {
        clearTimeOutFlipCamera();
        if ((request === null || request === void 0 ? void 0 : request.id) !== undefined) {
            setOpen(true);
            timeoutRef.current = setTimeout(() => {
                handleAbortCameraFlip();
            }, TIMEOUT_MS_FLIP_CAMERA_REQUEST);
        }
    }, [request === null || request === void 0 ? void 0 : request.id, setOpen, handleAbortCameraFlip]);
    const handleRejectCameraFlip = (0, react_1.useCallback)(() => {
        (0, toolbox_1.invariant)(request, 'Attempted to reject undefined request.');
        roomSession.camera.rejectCameraSubjectChangeRequest(request.id);
        setOpen(false);
        clearTimeOutFlipCamera();
    }, [request, roomSession.camera, setOpen]);
    const handleFulfillCameraFlip = (0, react_1.useCallback)(() => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b;
        (0, toolbox_1.invariant)(request, 'Attempted to fulfill undefined request.');
        roomSession.camera.fulfillCameraSubjectChangeRequest(request.id, (_a = request.requestedCameraSubject) !== null && _a !== void 0 ? _a : 0);
        const localVideo = yield (0, take_first_emitted_1.takeFirstEmitted)(roomSession.media.localVideoController);
        yield (localVideo === null || localVideo === void 0 ? void 0 : localVideo.flipCamera((_b = request.requestedCameraSubject) !== null && _b !== void 0 ? _b : 0));
        localVideo === null || localVideo === void 0 ? void 0 : localVideo.setEnabled(true);
        setOpen(false);
        clearTimeOutFlipCamera();
    }), [request, roomSession.camera, roomSession.media.localVideoController, setOpen]);
    let headerText = "Let's chat face-to-face";
    let copyText = 'Your rear camera will stop and the front camera will start.';
    let primaryButtonText = 'Start Front Camera';
    let secondaryButtonText = 'No, Thanks';
    if (request && request.requestedCameraSubject !== streem_sdk_protobuf_1.CameraSubject.CAMERA_SUBJECT_PERSON) {
        headerText = 'Can I see your space?';
        copyText = 'Your front camera will stop and the rear camera will start.';
        primaryButtonText = 'Start Rear Camera';
        secondaryButtonText = 'No, Thanks';
    }
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: open && ((0, jsx_runtime_1.jsx)(DarkTransparentOverlay, { children: (0, jsx_runtime_1.jsx)(ui_react_1.Column, Object.assign({ style: {
                    height: '100%',
                    width: '100%',
                    justifyContent: 'flex-end',
                    alignItems: 'center',
                } }, { children: (0, jsx_runtime_1.jsxs)(ui_react_1.Column, Object.assign({ style: { width: '75%' } }, { children: [(0, jsx_runtime_1.jsx)(ui_react_1.Header, Object.assign({ color: "white", bold: true, style: { marginBottom: '6px' } }, { children: headerText })), (0, jsx_runtime_1.jsx)(ui_react_1.AppText, Object.assign({ color: "white" }, { children: copyText })), (0, jsx_runtime_1.jsxs)(ui_react_1.ButtonColumn, Object.assign({ style: {
                                width: '100%',
                                marginBottom: '48px',
                                marginTop: '16px',
                            } }, { children: [(0, jsx_runtime_1.jsx)(ui_react_1.Button, Object.assign({ mobile: true, variant: "primary", onClick: handleFulfillCameraFlip, "data-testid": "fulfill-camera-flip" }, { children: (0, jsx_runtime_1.jsxs)(ui_react_1.Row, Object.assign({ style: { alignItems: 'center' } }, { children: [(0, jsx_runtime_1.jsx)(ui_react_1.AppIcon, { name: "CameraFlipIcon", style: { marginRight: '8px' } }), primaryButtonText] })) })), (0, jsx_runtime_1.jsx)(ui_react_1.Button, Object.assign({ variant: "transparent", mobile: true, onClick: handleRejectCameraFlip, "data-testid": "reject-camera-flip" }, { children: secondaryButtonText }))] }))] })) })) })) }));
};
exports.RequestCameraFlip = RequestCameraFlip;
const DarkTransparentOverlay = ui_react_1.styled.div `
    background-color: rgba(0, 0, 0, 0.7);
    z-index: ${({ theme }) => theme.layers.modal};
    position: absolute;
    width: 100%;
    height: 100%;
    ${ui_react_1.SafariLandscapeFullHeightHack}
`;
//# sourceMappingURL=request_camera_flip.js.map